import React, { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";
import ApiCalls from "../../apis/api-calls";

const DownloadsComponent = inject("sharedStore")(
  observer(store => {
    const { sharedStore } = store;
    const [showPage, setPage] = useState(1);
    const [newArr, setNewArr] = useState([]);
    const [downloadData, setVersionObj] = useState({});
    const [currVal, setCurrVal] = useState("");
    const [schemaMigrationData, setSchemaMigrationData] = useState({});

    const callResources = (e, version) => {
      sharedStore.showLoader();
      ApiCalls.fetchResources({ version: version })
        .then(res => {
          console.log(res);
          sharedStore.hideLoader();
          setVersionObj(res.data);
          setPage(2);
          sharedStore.setDownloadsData(res.data);
          setSchemaMigrationData(res.data.SchemaMigration.Databases);
          setNewArr([version]);
        })
        .catch(err => {
          sharedStore.hideLoader();
          console.log("err", err);
        });
    };

    useEffect(() => {
      console.log(newArr);
    }, [newArr]);

    const displayFiles = (e, key, showindex) => {
      let x = [];
      x.push(key);
      setPage(showindex);
      setCurrVal(key);
      setNewArr([...newArr, ...x]);
    };

    const renderBreadCrumList = () => {
      return (
        newArr &&
        newArr.map((val, i) => {
          return (
            <span key={i} className="bardcummenu">
              {" "}
              {val}/
            </span>
          );
        })
      );
    };

    const goBack = (e, currentIndex) => {
      setPage(currentIndex - 1);
      setNewArr([...newArr.slice(0, -1)]);
    };

    return (
      <div className="down_mainwrapper">
        <div className="wrap-block">
          <div className="header_wrapper">
            <div className="download_header">
              <a>Izenda Downloads</a>
            </div>
            {sharedStore.customerSeriesType === 0 ||
            sharedStore.customerSeriesType === 1 ? (
              <div className="dw_nt_txt">
                Note: Downloads are for Izenda 7 Series. For 6 Series downloads,
                please go to{" "}
                <a
                  rel="noopener noreferrer"
                  href="http://archives.izenda.us/"
                  target="_blank"
                >
                  http://archives.izenda.us
                </a>
              </div>
            ) : null}
          </div>
          <div className="downloadfiles container">
            {showPage > 1 ? (
              <div className="back_btn" onClick={e => goBack(e, showPage)}>
                Back
              </div>
            ) : null}
            <div className={showPage > 1 ? "alert alert-info" : "fullwidth"}>
              The Izenda{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://tools.izenda.com/"
              >
                {" "}
                <strong>Schema Migration Assistant </strong>{" "}
              </a>{" "}
              is now available. This tool helps you easily update your Izenda
              application by combining all required migration scripts into one
              file.
            </div>
            <div
              id="breadcumMenu"
              className="download_bradcum"
              data-breadcumindex={showPage}
            >
              / {renderBreadCrumList()}{" "}
            </div>
            <table>
              <thead>
                <tr>
                  <th>
                    <a>File Name</a>
                  </th>
                </tr>
              </thead>
              {showPage === 1 ? (
                <tbody>
                  {sharedStore.versionArr &&
                    sharedStore.versionArr.map((value, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <a onClick={e => callResources(e, value)}>
                              {value}/
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              ) : null}
              {showPage === 2 ? (
                <tbody>
                  {downloadData && downloadData.SchemaMigration ? (
                    <tr>
                      <td>
                        <a
                          onClick={e =>
                            displayFiles(e, "SchemaMigrationScripts", 3)
                          }
                        >
                          SchemaMigrationScripts /
                        </a>
                      </td>
                    </tr>
                  ) : null}
                  {downloadData &&
                    downloadData.Files &&
                    Object.keys(downloadData.Files).map((value, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <a
                              href={
                                "https://tool.izenda.com/Static/Files/" +
                                downloadData.Name +
                                "/" +
                                value
                              }
                            >
                              {value}
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              ) : null}
              {showPage === 3 ? (
                <tbody>
                  {Object.keys(schemaMigrationData) &&
                    Object.keys(schemaMigrationData).map((key, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <a onClick={e => displayFiles(e, key, 4)}>{key}</a>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              ) : null}
              {showPage === 4 ? (
                <tbody>
                  <tr>
                    <td>
                      <a
                        href={
                          "https://tool.izenda.com/Static/Files/" +
                          downloadData.Name +
                          "/SchemaMigrationScripts/" +
                          currVal +
                          "/" +
                          schemaMigrationData[currVal]["Key"]
                        }
                        download="download"
                        target="_blank"
                      >
                        {schemaMigrationData[currVal]["Key"]}
                      </a>
                    </td>
                  </tr>
                </tbody>
              ) : null}
            </table>
          </div>
        </div>
      </div>
    );
  })
);

export default DownloadsComponent;



// WEBPACK FOOTER //
// ./src/components/Profile/DownloadsComponent/DownloadsComponent.jsx